<div class="bar">
  <span class="title">Preview <span class="meta">on the website</span></span>
  <span class="devices">
    <button *ngFor="let d of devices" pButton type="button" class="p-button-sm p-button-text device" [class.on]="d.width === width"
            [icon]="d.icon" [attr.aria-label]="d.label" [attr.aria-pressed]="d.width === width" [pTooltip]="d.label + ' (' + d.width + ' px)'"
            tooltipPosition="bottom" (click)="setWidth(d.width)"></button>
  </span>
  <button pButton type="button" class="p-button-sm p-button-text preview-refresh" icon="pi pi-refresh" aria-label="Refresh" pTooltip="Refresh"
          tooltipPosition="bottom" (click)="refresh.emit()"></button>
  <button *ngIf="closable" pButton type="button" class="p-button-sm p-button-text preview-close" icon="pi pi-times" aria-label="Close preview"
          pTooltip="Close" tooltipPosition="bottom" (click)="closed.emit()"></button>
</div>

<ul *ngIf="state.notes.length" class="notes">
  <li *ngFor="let note of state.notes">{{ note }}</li>
</ul>

<div #viewport class="viewport" [attr.data-phase]="state.phase">
  <div *ngIf="updating" class="progress" role="progressbar" aria-label="Updating the preview"></div>
  <iframe *ngIf="srcdoc" sandbox="" referrerpolicy="no-referrer" title="Preview of this block on the website" [srcdoc]="srcdoc"
          [class.dim]="dimmed" [style.width.px]="width" [style.height.px]="frameHeight" [style.transform]="'scale(' + scale + ')'"></iframe>
  <div *ngIf="state.message" class="message" [class.over]="!!srcdoc" [class.problem]="dimmed && state.phase !== 'idle'">
    <span>{{ state.message }}</span>
    <button *ngIf="state.retry" pButton type="button" class="p-button-sm p-button-outlined preview-retry" icon="pi pi-refresh" label="Retry"
            (click)="refresh.emit()"></button>
  </div>
</div>
